import { ContentContainer } from "../core/types";
import { Logger } from "../core/Logger";

export class ContentScanner {
    scan(isMultiDealer: boolean): ContentContainer[] {
        Logger.debug("Scanning for content containers...");
        const containerElements = document.querySelectorAll<HTMLElement>('[data-selectfi-product]');
        
        const contentContainers: ContentContainer[] = [];
        Array.from(containerElements).forEach(element => {
            try {
                const container = ContentContainer.createFromElement(element, isMultiDealer);
                contentContainers.push(container);
            } catch (error) {
                Logger.warn('Failed to create container from element', error);
            }
        });
        
        Logger.debug(`Found ${contentContainers.length} content containers.`);
        return contentContainers;
    }
}
